import { createMutation } from '../api/mutation'

export const useInviteUser = createMutation({
    url: '/user',
    method: 'POST',
})

export const useDeleteUser = createMutation({
    url: '/user',
    method: 'DELETE',
})

export const useUploadProfilePhoto = createMutation({
    url: '/profile-picture',
    method: 'POST',
    apiOptions: {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    },
})

export const useDeleteProfilePhoto = createMutation({
    url: '/profile-picture',
    method: 'DELETE',
    apiOptions: {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    },
})

export const useSeedUserEnvironment = createMutation<{ success: boolean; data?: any; message?: string }>({
    url: '/admin/users/:userId/seed',
    method: 'POST',
    apiOptions: {
        headers: {
            'x-confirm-seed': 'true',
        },
    },
})

export const useUpdateUserInfo = createMutation({
    url: '/user',
    method: 'PATCH',
})

export const useInviteUsers = createMutation({
    url: '/invite-users',
    method: 'POST',
})

export const useRevokeInvite = createMutation({
    url: '/revoke-invite',
    method: 'POST',
})

export const useResendInvite = createMutation({
    url: '/resend-invitation',
    method: 'POST',
})

export const useUpdateBusinessAccountRole = createMutation({
    url: '/business-account-role',
    method: 'PATCH',
})

export const useSwitchOwnership = createMutation({
    url: '/switch-ownership',
    method: 'POST',
})

export const useInviteUsersToBusiness = createMutation({
    url: '/invite-to-business',
    method: 'POST',
})

export const useRevokeInviteToBusiness = createMutation({
    url: '/revoke-business-account',
    method: 'POST',
})

export const useUpdateWorkspaceAccess = createMutation({
    url: '/workspace-account',
    method: 'PATCH',
})

export const useContactSupport = createMutation({
    url: '/email/public/contact',
    method: 'POST',
})
